import "./App.css";

import LoadingPage from "./components/LoadingPage";
import { useEffect, useState, useRef } from "react";

import ScrollMenu from "./components/ScrollMenu";

import MyWork from "./components/work/MyWorks";
import { Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import TamerMenu from "./components/TamerMenu";
import { useLocation } from "react-router-dom";
import LoadingProvider from "./contexts/DisplayLoading";
import AboutMe from "./components/AboutMe";
import Contact from "./components/Contact";

import usePageTracking from "./hooks/usePageTracking";

function App() {
  usePageTracking();
  const words = [
    "Good morning",
    "Good afternoon",
    "Good evening",
    "Good night ! ",
  ];
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [loading, setLoading] = useState({
    state: isHome ? true : false, // Start with loading true
    text: words[0],
    animateLoad: isHome ? "0%" : "-100%",
  });
  const currentIndexRef = useRef(1); // Track index with a ref

  useEffect(() => {
    if (isHome) {
      const wordInterval = setInterval(() => {
        const currentIndex = currentIndexRef.current;

        setLoading((prev) => ({ ...prev, text: words[currentIndex] }));

        if (currentIndex === words.length - 1) {
          clearInterval(wordInterval);

          // Start revealing content before moving loading screen
          setTimeout(() => {
            setLoading((prev) => ({
              ...prev,
              animateLoad: "-100%",
            }));
            setTimeout(() => {
              setLoading((prev) => ({ ...prev, state: false }));
            }, 600);
          }, 300);
        } else {
          currentIndexRef.current += 1; // Update the ref's value
        }
      }, 500);

      return () => clearInterval(wordInterval);
    } else {
      // For non-home routes, hide initial loader after a delay
      const hideTimer = setTimeout(() => {
        setLoading((prev) => ({
          ...prev,
          animateLoad: "-100%",
        }));
        setTimeout(() => {
          setLoading((prev) => ({ ...prev, state: false }));
        }, 600);
      }, 300);

      return () => clearTimeout(hideTimer);
    }
  }, [location.pathname]);

  return (
    <>
      <LoadingProvider>
        <div
          className="App"
          style={{
            position: "relative",
            zIndex: 1,
            opacity: 1,
            transition: "opacity 0.6s ease-in-out",
            backgroundColor: "black",
          }}
        >
          <ScrollMenu />
          <TamerMenu />

          <Routes>
            <Route path="/work" element={<MyWork />} />
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </LoadingProvider>
      <LoadingPage animateLoad={loading.animateLoad} isVisible={loading.state}>
        {loading.text}
      </LoadingPage>
    </>
  );
}

export default App;
